import { InterventionActionTransition } from "@/modules/intervention/intervention-action-transition";
import { JobModuleActionCompleted } from "@/modules/job-module/job-module-action-completed";
import { JobModuleActionFailed } from "@/modules/job-module/job-module-action-failed";
import { JobModuleActionRunning } from "@/modules/job-module/job-module-action-running";
import {
  ModelDeleteAsyncActionFailed,
  ModelDeleteAsyncActionSuccess,
} from "@/modules/model-delete-async";
import { ObservationActionCommented } from "@/modules/observation/observation-action-commented";
import { ObservationActionTransition } from "@/modules/observation/observation-action-transition";

export const EventActionsHandler = () => {
  return (
    <>
      <InterventionActionTransition />
      <JobModuleActionRunning />
      <JobModuleActionCompleted />
      <JobModuleActionFailed />
      <ObservationActionCommented />
      <ObservationActionTransition />
      <ModelDeleteAsyncActionSuccess />
      <ModelDeleteAsyncActionFailed />
    </>
  );
};
